<template>
  <div class="login_footer">
    <!-- <div class="icp">
      <img src="../../assets/mobileImgs/new-Login_icon-footer.png" alt="" />
      <p>{{$getText('footer_icp')}}<span>{{$getText('footer_mun')}}</span></p>
    </div>
    <p>{{$getText('footer_int')}}<span>{{$getText('footer_int_num')}}</span></p>
    <p>{{$getText('footer_desc')}}<span>{{$getText('footer_info')}}</span></p> -->
    <div class="icp">
      <img src="../../assets/mobileImgs/new-Login_icon-footer.png" alt="" />
      <p>京ICP备<span>07035254号-1</span></p>
    </div>
    <p>京公网安备<span>11010102000192号</span></p>
    <p>出版物经营许可证<span>新出发京零字第东130025号</span></p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$bus.$on('footerUpdate', () => {
      this.$forceUpdate();
    })
  }
};
</script>
<style lang="scss" scoped>
.login_footer {
  margin: 20px;
  line-height: 26px;
  justify-content: flex-start;
}
.login_footer p {
  text-align: center;
  font-size: 13px;
  margin-right: 20px;
  color: #90949e;
}
.login_footer p span {
  padding-left: 10px;
}
.login_footer .icp {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;
  width: 235px;
  margin: 0 auto;
}
.login_footer .icp img {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/mobileComponents/footer.vue